import EditDialogProvider from "src/features/DialogProvider";
import DeleteDialogProvider from "src/features/DialogProvider";
import { useTranslation } from "src/hooks";
import EditButton from "./components/EditButton";
import DeleteButton from "./components/DeleteButton";
import EditDialog from "./components/EditDialog";
import DeleteDialog from "./components/DeleteDialog";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { TableRow } from "src/views/WalletManagement/WalletBalanceMonitor/types/Table";
import { FeatureCode } from "@wallet-manager/node-types";
import { GetListRes } from "src/views/WalletManagement/WalletBalanceMonitor/types/GetListRes";

function useOperationButton() {
  const { tc } = useTranslation("common");

  const renderOperationButtons = (
    params: GridRenderCellParams<any, TableRow & { rawData: GetListRes }, any>,
  ) => {
    return (
      <div
        style={{
          display: "flex",
          gap: "24px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <EditDialogProvider
          permissionKey={
            FeatureCode.FeaturesWalletManagement.WalletBalanceMonitor.Edit
          }
        >
          <EditButton />
          <EditDialog rowData={params.row} />
        </EditDialogProvider>
        <DeleteDialogProvider
          permissionKey={
            FeatureCode.FeaturesWalletManagement.WalletBalanceMonitor.Delete
          }
        >
          <DeleteButton />
          <DeleteDialog rowData={params.row} />
        </DeleteDialogProvider>
      </div>
    );
  };

  return { renderOperationButtons };
}

export default useOperationButton;
